$(document).ready(function () {
    $('.scroll-to').on('click', function (e) {
        e.preventDefault();
        var elementID = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(elementID).offset().top - 40
        }, 500);
    })
})